export function parseCompactDateTime(str: string): Date {
  if (!/^\d{14}$/.test(str)) throw new Error('Formato inválido. Esperado: yyyyMMddHHmmss');

  const year = parseInt(str.substring(0, 4));
  const month = parseInt(str.substring(4, 6)) - 1; // meses são 0-based
  const day = parseInt(str.substring(6, 8));
  const hour = parseInt(str.substring(8, 10));
  const minute = parseInt(str.substring(10, 12));
  const second = parseInt(str.substring(12, 14));

  return new Date(year, month, day, hour, minute, second);
}

export function formatCompactDateTime(date: Date): number {
  const pad = (n: number) => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hour = pad(date.getHours());
  const minute = pad(date.getMinutes());
  const second = pad(date.getSeconds());

  return Number(`${year}${month}${day}${hour}${minute}${second}`);
}
